import { DropdownFieldPopupContent, IDropdownValue, OutsideClick, Popup, PopupArrow } from '@cian/components';
import * as React from 'react';
import { ESortValue, IJsonQuery } from '../../../../../json_query';
import {
  dealTypeFromJsonQuery,
  FDealType,
  FOfferType,
  isCommercial,
  isCommercialCoworking,
  isFlat,
  isSuburban,
  isUrban,
  offerTypeFromJsonQuery,
} from '../../../../../utils/category';
import { MOId } from '../../../../../utils/geo';
import { items } from './contstants';
import { trackChangeSortEvent } from './utils/tracking';
import { Button } from '@cian/ui-kit/button';
import { Sort16 } from '@cian/ui-kit/icons';
import { TCurrentLocation } from '../../../../../common/state';
import * as styles from './SummarySortDropdown.css';
import { SummaryButtonWrapper } from '../SummaryButtonWrapper';

export interface ISortDropdownProps {
  isRedesignEnabled: boolean;
  currentLocation: TCurrentLocation;
  jsonQuery: IJsonQuery;
  onSortChanged(sort: ESortValue): void;
}

export interface ISummarySortDropdownState {
  selectedIndex: number;
  isOpen: boolean;
}

export class SummarySortDropdown extends React.Component<ISortDropdownProps, ISummarySortDropdownState> {
  public state = {
    isOpen: false,
    selectedIndex: 0,
  };

  public render() {
    const itemList = this.getSortValues();
    const { selectedIndex } = this.state;
    const { value: currentValue } = this.getCurrentSort();

    const activeIndex = itemList.findIndex(({ value }) => value === currentValue);
    const activeItem = itemList[activeIndex];

    return (
      <OutsideClick onOutsideClick={this.close} rootElement={<SummaryButtonWrapper />}>
        <Button
          size="XS"
          theme={this.props.isRedesignEnabled ? 'fill_white_primary' : 'fill_secondary'}
          data-mark="SortDropdownButton"
          beforeIcon={<Sort16 color="primary_100" />}
          onClick={this.handleClickOnLink}
        >
          {activeItem.label}
        </Button>
        {this.state.isOpen && (
          <Popup arrow={PopupArrow.NONE} containerStyle={styles['popup']}>
            <DropdownFieldPopupContent
              containerStyle={styles['dropdown']}
              valueStyle={styles['item']}
              valueActiveStyle={styles['item-active']}
              valueSelectedStyle={styles['item-selected']}
              values={itemList}
              value={[activeItem]}
              selectedValue={[itemList[selectedIndex]]}
              onValueMouseOver={this.handleMouseOverOnValue}
              onValueClick={this.handleClickOnValue}
            />
          </Popup>
        )}
      </OutsideClick>
    );
  }

  private close = () => {
    this.toggle(false);
  };

  private toggle = (isOpen = !this.state.isOpen) => {
    this.setState({ isOpen });
  };

  private handleClickOnLink = () => {
    this.toggle();
  };

  private getCurrentSort() {
    const itemList = this.getSortValues();
    const { jsonQuery } = this.props;
    const { sort } = jsonQuery;

    let activeItem: IDropdownValue = itemList[0];

    if (sort && sort.value) {
      activeItem = itemList.find(({ value }) => value === sort.value) || itemList[0];
    }

    return {
      value: activeItem.value as ESortValue,
    };
  }

  private handleClickOnValue = (newActiveItem: IDropdownValue) => {
    const { value } = this.getCurrentSort();

    if (value !== newActiveItem.value) {
      trackChangeSortEvent(newActiveItem.value as string);
      this.props.onSortChanged(newActiveItem.value as ESortValue);
    }

    this.close();
  };

  private handleMouseOverOnValue = (newSelectedItem: IDropdownValue) => {
    const itemList = this.getSortValues();
    const newSelectedIndex = itemList.findIndex(({ value }) => value === newSelectedItem.value);
    this.setState({
      selectedIndex: newSelectedIndex > 0 ? newSelectedIndex : 0,
    });
  };

  private getSortValues() {
    const { currentLocation, jsonQuery } = this.props;
    const offerType = offerTypeFromJsonQuery(jsonQuery);
    const dealType = dealTypeFromJsonQuery(jsonQuery);

    return items
      .filter(({ value }) => {
        switch (value) {
          case 'price_square_order':
          case 'price_square_order_desc':
            return (
              (isCommercial(offerType) && !isCommercialCoworking(offerType)) ||
              (isFlat(offerType) && dealType === FDealType.Sale)
            );
          case 'area_order':
            return !isCommercialCoworking(offerType) && offerType !== FOfferType.Land;
          case 'site_order':
            return isSuburban(offerType);
          case 'walking_time':
            return !isSuburban(offerType) && (typeof currentLocation === 'string' || currentLocation.hasMetro);
          case 'mcad':
            let isMosowArea = false;
            if (jsonQuery.region && Array.isArray(jsonQuery.region.value)) {
              isMosowArea = jsonQuery.region.value.includes(MOId);
            }

            return isSuburban(offerType) && isMosowArea;
          case 'street_name':
            return isUrban(offerType);
          default:
            return true;
        }
      })
      .map(({ value, label }) => {
        if (value === 'area_order') {
          return { label: isSuburban(offerType) ? 'По площади дома' : 'По общей площади', value };
        }

        return { value, label };
      });
  }
}
